// SimpleInput.js
import React from "react";
import { TextField } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  paper: { overflowY: "hidden", fontSize: 12 },
  autocomplete: {
    "& .MuiFormLabel-root": {
      fontSize: 12,
      color: "#1E1E1E",
      fontWeight: 400,
      fontFamily: "Nunito, sans-serif !important",
      top: "-5.7px !important",
      zIndex: 2,
    },
    "& .MuiFormLabel-asterisk": { color: "#e32b35 !important" },
    "& .MuiFormLabel-root.Mui-focused": { color: "#54565B !important" },
    "& .MuiInputLabel-filled.MuiInputLabel-shrink": {
      transform: " translate(9px, 12px) scale(0.75)",
      color: "#54565B",
    },

    fontFamily: "Nunito, sans-serif !important",
    "& .MuiAutocomplete-inputRoot": {
      "--end-gap": 0,
    },
    "& .MuiFilledInput-input::placeholder": { color: "#8A8A8A", opacity: 1 },
    "& .MuiFilledInput-root": {
      backgroundColor: "#ffffff",
      height: 42,
      fontSize: 12,
      border: "solid 1px #d4d4d4",
      paddingRight: "8px !important",
      paddingLeft: "8px !important",
      borderRadius: 6,
      paddingBottom: 0,
      paddingTop: 10,
      display: "flex",
      alignItems: "flex-start",
      boxSizing: "border-box",
    },
    "& .MuiFilledInput-root:hover": { backgroundColor: "#ffffff" },
    "& .MuiFilledInput-input": {
      lineHeight: "20px",
      height: 20,
      transition: "none",
      padding: "0 !important",
      color: "#000000",
      marginTop: 8,
      boxSizing: "border-box",
      minWidth: 0,
    },
    "& .MuiInputLabel-formControl": { top: "-4px", zIndex: 1 },
    "& .MuiFilledInput-underline :focus": { borderBottom: "none" },
    "& .MuiFilledInput-underline:before": { borderBottom: "none" },
    "& .MuiFilledInput-underline:after": { borderBottom: "none" },
    "& .MuiFilledInput-underline:hover:before": { borderBottom: "none" },
    "& .MuiInputBase-root.Mui-disabled": { border: "none !important" },
  },
}));

const SimpleInput = ({
  value = "",
  onChange,
  label = "",
  placeholder = "",
  name,
  disabled = false,
  required = false,
  type = "text",
  error = false,
  helperText = "",
  autoFocus = false,
  onBlur,
  onKeyDown,
  onFocus,
  fullWidth = true,
  id,
  inputProps,
}) => {
  const classes = useStyles();

  return (
    <div style={{ width: "100%", minWidth: 196 }}>
      <TextField
        id={id}
        name={name}
        variant="filled"
        label={label}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        type={type}
        error={error}
        helperText={helperText}
        autoFocus={autoFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        fullWidth={fullWidth}
        className={`${classes.autocomplete} ${classes.paper}`}
        inputProps={{
          autoComplete: "off",
          placeholder,
          ...inputProps,
        }}
      />
    </div>
  );
};

export default SimpleInput;
